import Icon from "@ch/components/Icons/Icon";
import type { FC } from "react";

export interface KemSpeechHeaderProps {
  onBack: () => void;
  backLabel?: string;
  title?: string;
}

/**
 * Top bar for Kem speech-to-speech — balanced title with a symmetric spacer for centering.
 */
const KemSpeechHeader: FC<KemSpeechHeaderProps> = ({
  onBack,
  backLabel = "Chat",
  title = "Talk to Kem",
}) => (
  <div className="flex items-center justify-between px-4 py-4">
    <button
      aria-label="Go back"
      className="flex items-center gap-2 text-white transition-opacity hover:opacity-80"
      onClick={onBack}
      type="button"
    >
      <Icon color="#FFFFFF" name="arrow-left" size={24} />
      <span className="text-base font-medium md:text-lg">{backLabel}</span>
    </button>

    <p className="text-base font-medium text-white md:text-xl">{title}</p>

    <div
      aria-hidden
      className="invisible flex items-center gap-2 text-white transition-opacity hover:opacity-80"
    >
      <Icon color="#FFFFFF" name="arrow-left" size={24} />
      <span className="text-base font-medium md:text-lg">{backLabel}</span>
    </div>
  </div>
);

export default KemSpeechHeader;
